import React from "react";
import { Head } from "next/document";
class LuluHead extends Head {
  render() {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-pascal-case
      React.createElement(Head.contextType.Consumer, null, value => /*#__PURE__*/React.createElement(Head.contextType.Provider, {
        value: Object.assign(value, {
          assetPrefix: global.__dynamicAssetPrefix || ""
        })
      }, super.render()))
    );
  }
}
export default LuluHead;